import {
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDataTable,
  CPagination,
  CRow,
  CLabel,
  CInputGroup,
  CInputGroupText,
  CInput,
  CSelect,
  CTooltip,
  CBadge,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getItem, getList } from "../../api/generics";
import { getRoutePath } from "../../routes";
import { SUCCESS } from "../../utils/constants/tags";
import { successAlert, warningAlert } from "../utils/messages";
import { formatDateTime } from "../../utils/dates";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import CashRegisterSelect from "../cash-register/CashRegisterSelect";
import CashRegisterOperation from "../../models/cash-register-operation";
import StoreSale, {
  STORESALETYPES,
  getStoreSaleOperationType,
} from "../../models/store-sale";
import { getPaymentTypeLabel } from "../../models/client";
import {
  formatToCurrency,
  formatToCurrencyRounded,
} from "../../currency/format";
import { PYG } from "../../currency/available-currencies";
import { defaultValueOnUndefined } from "../../utils/fields";
import SaleDetailModal from "./SaleDetailModal";
import generateSalesReportPDF from "../../utils/storeSalesPdfGenerator";
import SingleStoreSelect from "../store/SingleStoreSelect";
import Store from "../../models/store";
import SaleNullifyModal from "./SaleNullifyModal";
import UserSelect from "../user/UserSelect";
import User from "../../models/user";
import "../inventory-products/custom-style.css";
import { Spinner } from "react-bootstrap";
import CashbackInfoBadge from "../utils/CashbackInfoBadge";

const ITEMS_PER_PAGE = 30;
const ITEMS_PER_PAGE_FOR_REPORT = -1; // Basically No limit

const SaleOrderList = () => {
  const fields = [
    {
      key: "id",
      _classes: ["text-center"],
      label: "Nro de Venta",
    },
    {
      key: "documentNumber",
      _classes: ["text-center"],
      label: "Nro de factura",
    },
    {
      key: "orderDate",
      _classes: ["text-center"],
      label: "Fecha",
    },
    {
      key: "storeName",
      _classes: ["text-center"],
      label: "Sucursal",
    },
    {
      key: "sellerName",
      _classes: ["text-center"],
      label: "Usuario",
    },
    {
      key: "clientName",
      _classes: ["text-center"],
      label: "Cliente",
    },
    {
      key: "isReturnOperation",
      _classes: ["text-center"],
      label: "Tipo",
    },
    {
      key: "paymentType",
      _classes: ["text-center"],
      label: "Forma de pago",
    },
    {
      key: "noTaxed",
      _classes: ["text-center"],
      label: "Exentas",
    },
    {
      key: "taxed",
      _classes: ["text-center"],
      label: "Gravadas",
    },
    {
      key: "discountedPrice",
      _classes: ["text-center"],
      label: "Venta total",
    },
    {
      key: "iva",
      _classes: ["text-center"],
      label: "IVA",
    },
    {
      key: "saleProfit",
      _classes: ["text-center"],
      label: "Ganancia",
    },
    {
      key: "actions",
      _classes: ["text-center index-custom"],
      label: "Acciones",
      filter: false,
    },
  ];
  const [filterCashRegisterOperation, setFilterCashRegisterOperation] =
    useState<CashRegisterOperation | undefined>(undefined);

  const [filterStore, setFilterStore] = useState<Store | undefined>(undefined);

  const [filterUser, setFilterUser] = useState<User | undefined>(undefined);

  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showNullifyModal, setShowNullifyModal] = useState(false);

  const [startDate, setStartDate] = useState<string | moment.Moment>("");
  const [endDate, setEndDate] = useState<string | moment.Moment>("");
  const [filterType, setFilterType] = useState<string>("");
  const [filterPaymentType, setFilterPaymentType] = useState<string>("");
  const [search, setSearch] = useState<string>("");

  const [loading, setLoading] = useState(true);
  const [storeSale, setStoreSale] = useState<StoreSale | undefined>(undefined);
  const [storeSales, setStoreSales] = useState<StoreSale[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();
  const [enableReportButton, setEnableReportButton] = useState(true);
  const [generatingReport, setGeneratingReport] = useState(false);

  const [pageTotalPrice, setPageTotalPrice] = useState<number | undefined>(0);
  const [pageTotalProfit, setPageTotalProfit] = useState<number | undefined>(0);
  const [pageTotalCost, setPageTotalCost] = useState<number | undefined>(0);
  const [pageTotalDiscount, setPageTotalDiscount] = useState<
    number | undefined
  >(0);
  const [pageTotalCashback, setPageTotalCashback] = useState<
    number | undefined
  >(0);
  const [queryTotalPrice, setQueryTotalPrice] = useState<number | undefined>(
    undefined
  );
  const [queryTotalPaymentTypePrice, setQueryTotalPaymentTypePrice] = useState<
    number | undefined
  >(undefined);
  const [queryTotalProfit, setQueryTotalProfit] = useState<number | undefined>(
    undefined
  );
  const [queryTotalCost, setQueryTotalCost] = useState<number | undefined>(
    undefined
  );

  const [queryTotalDiscount, setQueryTotalDiscount] = useState<
    number | undefined
  >(undefined);

  const [queryTotalCashback, setQueryTotalCashback] = useState<
    number | undefined
  >(undefined);

  const [queryNetTotal, setQueryNetTotal] = useState<number | undefined>(
    undefined
  );

  const getURLParams = () => {
    let urlParams = new URLSearchParams(history.location.search);
    let page = urlParams.get("page")
      ? parseInt(urlParams.get("page") as string)
      : 1;

    if (page <= 0) {
      page = 1;
    }
    let search = urlParams.get("search") ? urlParams.get("search") : "";
    let paymentType = urlParams.get("payment_type")
      ? urlParams.get("payment_type")
      : "";
    let isReturnal = urlParams.get("is_returnal")
      ? urlParams.get("is_returnal")
      : "";
    let cashRegisterOperationId = urlParams.get("cash_register_operation_id")
      ? urlParams.get("cash_register_operation_id")
      : "";
    let storeId = urlParams.get("store_id") ? urlParams.get("store_id") : "";
    let sellerId = urlParams.get("seller_id") ? urlParams.get("seller_id") : "";
    let startDate = urlParams.get("start_date")
      ? urlParams.get("start_date")
      : "";
    let endDate = urlParams.get("end_date") ? urlParams.get("end_date") : "";
    let map = new Map();
    map.set("search", search);
    map.set("page", page);
    if (isReturnal !== "") map.set("is_returnal", isReturnal);
    if (paymentType !== "") map.set("payment_type", paymentType);
    if (startDate !== "") map.set("start_date", startDate);
    if (endDate !== "") map.set("end_date", endDate);
    if (cashRegisterOperationId !== "")
      map.set("cash_register_operation_id", cashRegisterOperationId);
    if (storeId !== "") map.set("store_id", storeId);
    if (sellerId !== "") map.set("seller_id", sellerId);
    return map;
  };

  const fetchStoreSales = async () => {
    const urlParams = getURLParams();
    const limit = ITEMS_PER_PAGE;
    const offset = ITEMS_PER_PAGE * Number(urlParams.get("page") - 1);
    const storeSalesStatus = await getList<StoreSale>(
      "/store_sales/",
      limit,
      offset,
      urlParams
    );
    if (storeSalesStatus.status === SUCCESS) {
      if (storeSalesStatus.data !== undefined) {
        const count = storeSalesStatus.data.count;
        const pages = Math.ceil((count ? count : 0) / ITEMS_PER_PAGE);
        setTotalPages(pages);
        setPageTotalPrice(calculatePageTotal(storeSalesStatus.data.items));
        setPageTotalProfit(
          calculatePageTotalProfit(storeSalesStatus.data.items)
        );
        setPageTotalCost(calculatePageTotalCost(storeSalesStatus.data.items));
        setPageTotalDiscount(
          calculatePageDiscount(storeSalesStatus.data.items)
        );
        setPageTotalCashback(
          calculatePageCashback(storeSalesStatus.data.items)
        );
        setStoreSales(storeSalesStatus.data.items);
        setCurrentPage(urlParams.get("page"));
      }
    } else {
      const message = storeSalesStatus.detail
        ? storeSalesStatus.detail
        : "Error desconocido";
      warningAlert(message);
    }
    setLoading(false);
  };

  const calculatePageTotal = (sales: StoreSale[]): number => {
    const total = sales
      .filter((sale) => !sale.cancelled)
      .reduce((acc, sale) => {
        const price = sale.discountedPrice ?? 0;
        return acc + price;
      }, 0);

    return total;
  };

  const calculatePageDiscount = (sales: StoreSale[]): number => {
    const total = sales
      .filter((sale) => !sale.cancelled)
      .reduce((acc, sale) => {
        const price = sale.totalDiscount ?? 0;
        return acc + price;
      }, 0);

    return total;
  };

  // El reintegro no baja discountedPrice, por eso se suma aparte y el neto de
  // la pagina sale de restar los dos totales.
  const calculatePageCashback = (sales: StoreSale[]): number => {
    const total = sales
      .filter((sale) => !sale.cancelled)
      .reduce((acc, sale) => {
        const cashback = sale.cashbackAmount ?? 0;
        return acc + cashback;
      }, 0);

    return total;
  };

  const calculatePageTotalProfit = (sales: StoreSale[]): number => {
    const total = sales
      .filter((sale) => !sale.cancelled)
      .reduce((acc, sale) => {
        const price = sale.saleProfit ?? 0;
        return acc + price;
      }, 0);

    return total;
  };

  const calculatePageTotalCost = (sales: StoreSale[]): number => {
    const total = sales
      .filter((sale) => !sale.cancelled)
      .reduce((acc, sale) => {
        const price = sale.saleProductCosts ?? 0;
        return acc + price;
      }, 0);

    return total;
  };

  const fetchTotals = async () => {
    const urlParams = getURLParams();
    const limit = ITEMS_PER_PAGE;
    const offset = ITEMS_PER_PAGE * Number(urlParams.get("page") - 1);
    urlParams.set("limit", limit);
    urlParams.set("offset", offset);
    const totalsStatus = await getItem<{
      fullCost?: number;
      fullTotal?: number;
      fullProfit?: number;
      fullDiscount?: number;
      fullCashback?: number;
      fullNetTotal?: number;
      fullPaymentTypeTotal?: number;
    }>("/store_sales/totals/", urlParams);
    if (totalsStatus.status === SUCCESS) {
      if (totalsStatus.data !== undefined) {
        setQueryTotalPrice(totalsStatus.data.fullTotal);
        setQueryTotalPaymentTypePrice(totalsStatus.data.fullPaymentTypeTotal);
        setQueryTotalProfit(totalsStatus.data.fullProfit);
        setQueryTotalCost(totalsStatus.data.fullCost);
        setQueryTotalDiscount(totalsStatus.data.fullDiscount);
        setQueryTotalCashback(totalsStatus.data.fullCashback);
        setQueryNetTotal(totalsStatus.data.fullNetTotal);
      }
    } else {
      const message = totalsStatus.detail
        ? totalsStatus.detail
        : "Error desconocido";
      warningAlert(message);
    }
    setLoading(false);
  };

  const fetchStoreSalesReport = async () => {
    const urlParams = getURLParams();
    urlParams.set("descending", "false");
    const limit = ITEMS_PER_PAGE_FOR_REPORT;
    const offset = 0;
    const storeSalesStatus = await getList<StoreSale>(
      "/store_sales/",
      limit,
      offset,
      urlParams
    );
    if (storeSalesStatus.status === SUCCESS) {
      if (storeSalesStatus.data !== undefined) {
        return storeSalesStatus.data.items;
      }
      return [];
    } else {
      return [];
    }
  };

  const onPageChange = (page: number) => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    let previousParams = getURLParams();
    urlParams.set(
      "search",
      previousParams.get("search") ? previousParams.get("search") : ""
    );
    if (previousParams.get("is_returnal")) {
      urlParams.set("is_returnal", previousParams.get("is_returnal"));
    }
    if (previousParams.get("payment_type")) {
      urlParams.set("payment_type", previousParams.get("payment_type"));
    }
    if (previousParams.get("cash_register_operation_id")) {
      urlParams.set(
        "cash_register_operation_id",
        previousParams.get("cash_register_operation_id")
      );
    }
    if (previousParams.get("store_id")) {
      urlParams.set("store_id", previousParams.get("store_id"));
    }
    if (previousParams.get("seller_id")) {
      urlParams.set("seller_id", previousParams.get("seller_id"));
    }
    if (previousParams.get("start_date")) {
      urlParams.set("start_date", previousParams.get("start_date"));
    }
    if (previousParams.get("end_date")) {
      urlParams.set("end_date", previousParams.get("end_date"));
    }
    urlParams.set("page", page.toString());
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const onStartDatehange = (value: string | moment.Moment) => {
    const newDate = value as moment.Moment;
    if (newDate === undefined || !moment(value, true).isValid()) {
      setStartDate("");
      return;
    }
    setStartDate(value);
  };

  const onEndDatehange = (value: string | moment.Moment) => {
    const newDate = value as moment.Moment;
    if (newDate === undefined || !moment(value, true).isValid()) {
      setEndDate("");
      return;
    }
    setEndDate(value);
  };

  const onFilterTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterType(e.target.value);
  };

  const onFilterPaymentTypeChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFilterPaymentType(e.target.value);
  };

  const onCashRegisterOperationChange = (
    cashRegisterOperation: CashRegisterOperation | null
  ) => {
    setFilterCashRegisterOperation(
      cashRegisterOperation !== null ? cashRegisterOperation : undefined
    );
  };

  const onFilterStoreChange = (newStore: Store | null) => {
    setFilterStore(newStore !== null ? newStore : undefined);
  };

  const onFilterUserChange = (newUser: User | null) => {
    setFilterUser(newUser !== null ? newUser : undefined);
  };

  const onDetailClick = (storeSale: StoreSale) => {
    setStoreSale(storeSale);
    setShowDetailModal(true);
  };

  const onDetailModalCancel = () => {
    setStoreSale(undefined);
    setShowDetailModal(false);
  };

  const onNullifyClick = (storeSale: StoreSale) => {
    setStoreSale(storeSale);
    setShowNullifyModal(true);
  };

  const onNullifyCancel = () => {
    setStoreSale(undefined);
    setShowNullifyModal(false);
  };

  const onNullifySuccess = () => {
    successAlert("Venta anulada con éxito!");
    setShowNullifyModal(false);
    setStoreSales([]);
    setLoading(true);
    fetchStoreSales();
    fetchTotals();
  };

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onSearch = () => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    if (search !== "") {
      urlParams.set("search", search);
    } else {
      urlParams.delete("search");
    }
    if (filterType === "returnOperation") {
      urlParams.set("is_returnal", "true");
    } else if (filterType === "saleOperation") {
      urlParams.set("is_returnal", "false");
    } else {
      urlParams.delete("is_returnal");
    }
    if (filterPaymentType !== "") {
      urlParams.set("payment_type", filterPaymentType);
    } else {
      urlParams.delete("payment_type");
    }
    if (
      filterCashRegisterOperation !== undefined &&
      filterCashRegisterOperation.id !== undefined
    ) {
      urlParams.set(
        "cash_register_operation_id",
        filterCashRegisterOperation.id.toString()
      );
    } else {
      urlParams.delete("cash_register_operation_id");
    }
    if (filterStore !== undefined && filterStore.id !== undefined) {
      urlParams.set("store_id", filterStore.id.toString());
    } else {
      urlParams.delete("store_id");
    }
    if (filterUser !== undefined && filterUser.id !== undefined) {
      urlParams.set("seller_id", filterUser.id.toString());
    } else {
      urlParams.delete("seller_id");
    }
    if (moment.isMoment(startDate)) {
      urlParams.set("start_date", startDate.toISOString());
    } else if (startDate !== undefined && startDate !== "") {
      urlParams.set("start_date", startDate);
    } else {
      urlParams.delete("start_date");
    }
    if (moment.isMoment(endDate)) {
      urlParams.set("end_date", endDate.toISOString());
    } else if (endDate !== undefined && endDate !== "") {
      urlParams.set("end_date", endDate);
    } else {
      urlParams.delete("end_date");
    }
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  const evaluateReport = async () => {
    setGeneratingReport(false);
    const urlParams = getURLParams();

    const startDateStr = urlParams.get("start_date");
    const endDateStr = urlParams.get("end_date") || new Date().toISOString();

    if (!startDateStr) {
      setEnableReportButton(false);
      return;
    }

    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      setEnableReportButton(false);
      return;
    }

    const diffInDays = Math.floor(
      (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
    );
    if (diffInDays > 31) {
      setEnableReportButton(false);
      return;
    }
    setEnableReportButton(true);
  };

  const onReportClick = async () => {
    setEnableReportButton(false);
    setGeneratingReport(true);
    const urlParams = getURLParams();

    const startDateStr = urlParams.get("start_date");
    const endDateStr = urlParams.get("end_date") || new Date().toISOString();

    if (!startDateStr) {
      warningAlert(
        "El rango de fechas para reporte no debe ser mayor a un mes (31 días)."
      );
      setEnableReportButton(true);
      setGeneratingReport(false);
      return;
    }

    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    // Verificar que las fechas sean válidas
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      warningAlert("Los parámetros de fechas son inválidos.");
      setEnableReportButton(true);
      setGeneratingReport(false);
      return;
    }

    // Verificar rango de fechas (máximo 31 días)
    const diffInDays = Math.floor(
      (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
    );
    if (diffInDays > 31) {
      warningAlert(
        "El rango de fechas para reporte no debe ser mayor a un mes (31 días)."
      );
      setEnableReportButton(true);
      setGeneratingReport(false);
      return;
    }

    const reportSales = await fetchStoreSalesReport();
    if (reportSales.length <= 0) {
      warningAlert("No se han seleccionado ventas");
      setEnableReportButton(true);
      setGeneratingReport(false);
      return;
    }

    const titlesRight: string[] = generateTitlesRight(urlParams);

    const filteredTitlesRight = titlesRight.filter((title) => title !== "");
    await generateSalesReportPDF(
      reportSales,
      [
        "Reporte de Ventas",
        "",
        "Reporte generado el:",
        formatDateTime(new Date()),
      ],
      filteredTitlesRight,
      undefined
    );
    setEnableReportButton(true);
    setGeneratingReport(false);
  };

  const getPaymentFromURL = () => {
    const urlParams = getURLParams();
    if (urlParams.get("payment_type")) return urlParams.get("payment_type");
    return null;
  };

  const generateTitlesRight = (map: Map<any, any>): string[] => {
    const titlesRight: string[] = ["Filtros Utilizados: "];

    map.forEach((value, key) => {
      const stringKey = typeof key === "string" ? key : "";
      const stringValue = typeof value === "string" ? value : "";
      const description = getFilterDescription(stringKey, stringValue);
      titlesRight.push(description);
    });

    return titlesRight;
  };

  const getFilterDescription = (key: string, value: string) => {
    switch (key) {
      case "search":
        if (value !== "") {
          return `Búsqueda: ${value}`;
        } else {
          return "";
        }
      case "is_returnal":
        if (value === "true") {
          return "Tipo de Operación: Devolución";
        } else if (value === "false") {
          return "Tipo de Operación: Devolución";
        } else {
          return "";
        }
      case "cash_register_operation_id":
        return `Corresponde a ciclo de caja: Si`;
      case "start_date":
        return `Fecha de inicio: ${formatDateTime(new Date(value))}`;
      case "end_date":
        return `Fecha de fin: ${formatDateTime(new Date(value))}`;
      default:
        return "";
    }
  };

  useEffect(() => {
    fetchStoreSales();
    evaluateReport();
    fetchTotals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return history.listen((location) => {
      if (location.pathname !== getRoutePath("salesHistory")) {
        return;
      }
      fetchStoreSales();
      evaluateReport();
      fetchTotals();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <>
      <CRow>
        <CCol lg="12">
          <CCard>
            <CCardHeader className="d-flex flex-row mb-3">
              <div className="p-2 ">
                <h3>
                  Registro de ventas / Gestión de devoluciones / Libro de ventas
                </h3>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol>
                  {generatingReport ? (
                    <CButton
                      color="danger"
                      className="fa-solid fa-file-pdf"
                      onClick={onReportClick}
                      disabled={!enableReportButton}
                    >
                      <Spinner
                        animation="grow"
                        style={{
                          height: "17px",
                          width: "17px",
                          marginTop: "auto",
                          marginBottom: "auto",
                          marginRight: "10px",
                        }}
                      />
                      Generando...
                    </CButton>
                  ) : (
                    <CTooltip
                      content={
                        !enableReportButton || loading
                          ? "Debe seleccionar un rango máximo de 31 días"
                          : "La generación de un reporte podria demorar unos minutos. Tenga paciencia"
                      }
                    >
                      <CButton
                        color="danger"
                        className="fa-solid fa-file-pdf"
                        onClick={onReportClick}
                        disabled={!enableReportButton || loading}
                      ></CButton>
                    </CTooltip>
                  )}
                  <p>
                    La generación de reporte esta limitada a un rango de 1 mes
                  </p>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <h5>Filtros</h5>
                </CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Caja:</CLabel>
                </CCol>
                <CCol>
                  <CashRegisterSelect
                    value={
                      filterCashRegisterOperation
                        ? filterCashRegisterOperation
                        : null
                    }
                    onChange={onCashRegisterOperationChange}
                  ></CashRegisterSelect>
                </CCol>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Venta/devolucion:</CLabel>
                </CCol>
                <CCol>
                  <CSelect
                    type="text"
                    defaultValue={filterType !== null ? filterType : ""}
                    onChange={onFilterTypeChange}
                  >
                    <option value={""}>-----</option>
                    {Object.entries(STORESALETYPES).map(([key, entry], ix) => {
                      return (
                        <option key={ix} value={key}>
                          {entry}
                        </option>
                      );
                    })}
                  </CSelect>
                </CCol>
              </CRow>
              <CRow>
                <CCol></CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Desde:</CLabel>
                </CCol>
                <CCol>
                  <Datetime
                    className="pl-0"
                    onChange={onStartDatehange}
                    value={startDate}
                    locale="es/PY"
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    closeOnSelect={true}
                  ></Datetime>
                </CCol>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Hasta:</CLabel>
                </CCol>
                <CCol>
                  <Datetime
                    className="pl-0"
                    onChange={onEndDatehange}
                    value={endDate}
                    locale="es/PY"
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    closeOnSelect={true}
                  ></Datetime>
                </CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Sucursal:</CLabel>
                </CCol>
                <CCol>
                  <SingleStoreSelect
                    value={filterStore ? filterStore : null}
                    onChange={onFilterStoreChange}
                  ></SingleStoreSelect>
                </CCol>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Usuario Venta:</CLabel>
                </CCol>
                <CCol style={{ zIndex: 2 }}>
                  <UserSelect
                    value={filterUser ? filterUser : null}
                    onChange={onFilterUserChange}
                  ></UserSelect>
                </CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Medio de pago:</CLabel>
                </CCol>
                <CCol>
                  <CSelect
                    type="text"
                    defaultValue={
                      filterPaymentType !== null ? filterPaymentType : ""
                    }
                    onChange={onFilterPaymentTypeChange}
                  >
                    <option value={""}>-----</option>
                    <option value={"cash"}>Efectivo</option>
                    <option value={"credit_card"}>Tarjeta crédito</option>
                    <option value={"debit_card"}>Tarjeta débito</option>
                    <option value={"qr_payment"}>QR</option>
                    <option value={"transfer"}>Transferencia bancaria</option>
                  </CSelect>
                </CCol>
              </CRow>

              <CRow>
                <CCol>
                  <CLabel
                    className="visually-hidden"
                    htmlFor="autoSizingInputGroup"
                  ></CLabel>
                  <CInputGroup>
                    <CInputGroupText>
                      <i className="fa fa-search"></i>
                    </CInputGroupText>
                    <CInput
                      type="text"
                      placeholder="Introduzca el termino de busqueda (factura/cliente)"
                      onChange={onSearchChange}
                      value={search}
                      onKeyDown={handleKeyDown}
                    />
                    <CButton
                      type="button"
                      color="primary"
                      variant="outline"
                      onClick={onSearch}
                    >
                      Filtrar
                    </CButton>
                  </CInputGroup>
                </CCol>
              </CRow>
              <div>
                <div className="table-container-tall">
                  <CDataTable
                    noItemsView={
                      <h2 className="text-center">Sin Resultados</h2>
                    }
                    addTableClasses={"table-fixed table-fixed-custom"}
                    fields={fields}
                    items={storeSales}
                    striped
                    border
                    loading={loading}
                    responsive
                    scopedSlots={{
                      id: (item: StoreSale) => {
                        return (
                          <td className="text-center">
                            <span className="">
                              {item.id ? `#${item.id}` : "-"}
                            </span>
                            {item.sourceExchangeId ? (
                              <CBadge color={"info"} className={"ml-1"}>
                                {`Dif. cambio #${item.sourceExchangeId}`}
                              </CBadge>
                            ) : null}
                            {item.cancelled ? (
                              <div>
                                <CBadge color={"danger"}>
                                  Operación Anulada
                                </CBadge>
                              </div>
                            ) : null}
                          </td>
                        );
                      },
                      documentNumber: (item: StoreSale) => {
                        return (
                          <td className="text-center">
                            {item.documentNumber
                              ? `${item.establishment}-${item.dispatchPoint}-${item.documentNumber}`
                              : "-"}
                          </td>
                        );
                      },

                      orderDate: (item: StoreSale) => {
                        return (
                          <td className="text-center">
                            {item.saleDate
                              ? formatDateTime(new Date(item.saleDate))
                              : "-"}
                          </td>
                        );
                      },
                      clientName: (item: StoreSale) => {
                        const docNumber =
                          item.clientRuc ?? item.clientDocument;
                        return (
                          <td className="text-center">
                            <div>
                              {defaultValueOnUndefined(
                                "SIN NOMBRE",
                                item.clientName
                              )}
                            </div>
                            {docNumber ? (
                              <small className="text-muted">{docNumber}</small>
                            ) : null}
                          </td>
                        );
                      },
                      storeName: (item: StoreSale) => {
                        return (
                          <td className="text-center">
                            {defaultValueOnUndefined("-", item.storeName)}
                          </td>
                        );
                      },
                      paymentType: (item: StoreSale) => {
                        return (
                          <td className="text-center">
                            {item.paymentType ? getPaymentTypeLabel(item) : "-"}
                          </td>
                        );
                      },
                      isReturnOperation: (item: StoreSale) => {
                        return (
                          <td className="text-center">
                            {getStoreSaleOperationType(item)}
                          </td>
                        );
                      },
                      noTaxed: (item: StoreSale) => {
                        const show = item.isReturnOperation
                          ? !item.isReturnOperation
                          : true;

                        return (
                          <td className="text-center">
                            {show
                              ? item.noTaxed
                                ? formatToCurrency(item.noTaxed, PYG)
                                : "-"
                              : "-"}
                          </td>
                        );
                      },

                      taxed: (item: StoreSale) => {
                        const show = item.isReturnOperation
                          ? !item.isReturnOperation
                          : true;
                        return (
                          <td className="text-center">
                            {show
                              ? item.taxed
                                ? formatToCurrency(item.taxed, PYG)
                                : "-"
                              : "-"}
                          </td>
                        );
                      },
                      discountedPrice: (item: StoreSale) => {
                        const map = getURLParams();
                        const selectedPaymentType = map.get("payment_type");
                        let paymentToShow;
                        if (item.paymentType === selectedPaymentType) {
                          paymentToShow = item.paymentTypeAmount;
                        } else if (item.paymentType2 === selectedPaymentType) {
                          paymentToShow = item.paymentType2Amount;
                        }
                        return (
                          <td className="text-center">
                            {item.discountedPrice
                              ? formatToCurrency(item.discountedPrice, PYG)
                              : "-"}{" "}
                            {selectedPaymentType &&
                            paymentToShow &&
                            paymentToShow !== item.discountedPrice
                              ? `(${formatToCurrency(paymentToShow, PYG)})`
                              : null}
                            {/* El reintegro se factura pleno, asi que no se
                                descuenta de arriba: se agrega debajo en la
                                misma celda y solo en las ventas que lo
                                generaron. */}
                            {item.cashbackAmount ? (
                              <>
                                <div className="small text-danger">
                                  {`Reintegro: -${formatToCurrency(
                                    item.cashbackAmount,
                                    PYG
                                  )}`}
                                </div>
                                <div className="small font-weight-bold">
                                  {`Neto: ${formatToCurrency(
                                    (item.discountedPrice ?? 0) -
                                      item.cashbackAmount,
                                    PYG
                                  )}`}
                                </div>
                              </>
                            ) : null}
                          </td>
                        );
                      },

                      iva: (item: StoreSale) => {
                        const show = item.isReturnOperation
                          ? !item.isReturnOperation
                          : true;
                        return (
                          <td className="text-center">
                            {show
                              ? item.iva
                                ? formatToCurrency(item.iva, PYG)
                                : "-"
                              : "-"}
                          </td>
                        );
                      },

                      saleProfit: (item: StoreSale) => {
                        const show = item.isReturnOperation
                          ? !item.isReturnOperation
                          : true;
                        return (
                          <td className="text-center">
                            {show
                              ? item.saleProfit
                                ? formatToCurrency(item.saleProfit, PYG)
                                : "-"
                              : "-"}
                          </td>
                        );
                      },

                      actions: (item: StoreSale) => {
                        const detailButton = (
                          <CTooltip content={"Ver Detalles"}>
                            <CButton
                              className="text-white"
                              color="primary"
                              onClick={() => {
                                onDetailClick(item);
                              }}
                            >
                              <i className="fa fa-eye"></i>
                            </CButton>
                          </CTooltip>
                        );

                        const nullifyButton = (
                          <CTooltip content={"Anular Venta"}>
                            <CButton
                              className="text-white"
                              color="danger"
                              onClick={() => {
                                onNullifyClick(item);
                              }}
                            >
                              <i className="fa fa-circle-xmark"></i>
                            </CButton>
                          </CTooltip>
                        );

                        return (
                          <td className="text-right">
                            <CButtonGroup>
                              {detailButton}
                              {!item.isReturnOperation && !item.cancelled
                                ? nullifyButton
                                : null}
                            </CButtonGroup>
                          </td>
                        );
                      },
                    }}
                  />
                </div>
                <div className="d-flex justify-content-center">
                  <CPagination
                    pages={totalPages}
                    activePage={currentPage}
                    onActivePageChange={(i: number) => onPageChange(i)}
                    className={totalPages < 2 ? "d-none" : "mt-2"}
                  />
                </div>
              </div>
              <CRow className={"mt-2"}>
                <CCol className={"border border-dark"}>
                  <CRow className={"mt-2"}>
                    <CCol>
                      <h5>Valores Totales de selección:</h5>
                    </CCol>
                  </CRow>
                  <CRow className={"mt-2"}>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Venta total de la pagina visualizada:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {pageTotalPrice
                          ? formatToCurrency(pageTotalPrice, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Venta total todas las páginas:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {queryTotalPrice
                          ? formatToCurrency(queryTotalPrice, PYG)
                          : "-"}
                        {getPaymentFromURL() !== null &&
                        queryTotalPaymentTypePrice
                          ? ` (${formatToCurrency(
                              queryTotalPaymentTypePrice,
                              PYG
                            )})`
                          : null}
                      </CLabel>
                    </CCol>
                  </CRow>
                  <CRow className={"mt-2"}>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Costo total de productos vendidos de la pagina
                        visualizada:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {pageTotalCost
                          ? formatToCurrency(pageTotalCost, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Costo total todas las páginas:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {queryTotalCost
                          ? formatToCurrency(queryTotalCost, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                  </CRow>
                  <CRow className={"mt-2"}>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Ganancia total de la pagina visualizada:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {pageTotalProfit
                          ? formatToCurrency(pageTotalProfit, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Ganancia total todas las páginas:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {queryTotalProfit
                          ? formatToCurrency(queryTotalProfit, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                  </CRow>
                  <CRow className={"mt-2"}>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Descuento total de la pagina visualizada:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {pageTotalDiscount
                          ? formatToCurrencyRounded(pageTotalDiscount, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Descuento total todas las páginas:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {queryTotalDiscount
                          ? formatToCurrencyRounded(queryTotalDiscount, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                  </CRow>
                  {/* El reintegro va en filas propias y no dentro del
                      descuento: el descuento baja lo facturado y el reintegro
                      no, solo saca plata del cajon. Se muestran siempre, con
                      "-" cuando no hubo, para que se note la diferencia entre
                      "no hubo reintegros" y "la pantalla no los muestra". */}
                  <CRow className={"mt-2"}>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        <CashbackInfoBadge />
                        Reintegro total de la pagina visualizada:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {pageTotalCashback
                          ? formatToCurrency(pageTotalCashback, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        <CashbackInfoBadge />
                        Reintegro total todas las páginas:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {queryTotalCashback
                          ? formatToCurrency(queryTotalCashback, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                  </CRow>
                  <CRow className={"mt-2"}>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Venta neta (menos reintegros) de la pagina visualizada:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {pageTotalPrice !== undefined
                          ? formatToCurrency(
                              pageTotalPrice - (pageTotalCashback ?? 0),
                              PYG
                            )
                          : "-"}
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        Venta neta (menos reintegros) todas las páginas:
                      </CLabel>
                    </CCol>
                    <CCol md={3}>
                      <CLabel className={"mt-2 font-weight-bold"}>
                        {queryNetTotal !== undefined
                          ? formatToCurrency(queryNetTotal, PYG)
                          : "-"}
                      </CLabel>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <SaleDetailModal
        show={showDetailModal}
        storeSale={storeSale}
        onCancel={onDetailModalCancel}
      ></SaleDetailModal>
      <SaleNullifyModal
        show={showNullifyModal}
        storeSale={storeSale}
        onCancel={onNullifyCancel}
        onSuccess={onNullifySuccess}
      ></SaleNullifyModal>
    </>
  );
};

export default SaleOrderList;
